import { useStoreon } from 'storeon/react';
import React, { useState } from 'react';
import { Events, State } from '@/interfaces';
import FiltersOverlay from './components/FiltersOverlay';
import TableCertificates from './components/TableCertificates';
import styles from './components/TableCertificates/styles/index.module.scss';
import Pagination from '../../components/Pagination';

const Certificates = (): React.ReactElement => {
  const {
    dispatch,
    certificates,
    certificatesParamsApi
  } = useStoreon<State, Events>(
    'certificates',
    'certificatesParamsApi'
  );

  const [activePage, setActivePage] = useState<number>(certificatesParamsApi.page);

  const handleChangePage = (page: number) => {
    setActivePage(page);
    dispatch('certificatesApi/change', { page });
    dispatch('certificates/get', {});
  };

  return (
    <FiltersOverlay >
        <TableCertificates />
        <div className={styles['pagination']}>
          <Pagination
            onChange={(page: number) => handleChangePage(page)}
            total={certificates.count}
            pageSize={certificatesParamsApi.limit}
            activePage={activePage}
          />
        </div>
    </FiltersOverlay>
  )
};

export default Certificates;
